/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Findus_Proptech_SummaryInputs */

const en_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Led the front-end architecture for property technology products with disciplined systems and polished UI delivery.`)
};

const ar_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قدت معمارية الواجهة الأمامية لمنتجات تقنية العقارات، مع أنظمة منضبطة وواجهات مصقولة.`)
};

const bn_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিয়মতান্ত্রিক সিস্টেম ও পলিশড UI ডেলিভারির মাধ্যমে প্রপার্টি টেকনোলজি পণ্যের ফ্রন্ট-এন্ড আর্কিটেকচার নেতৃত্ব দিয়েছি।`)
};

const de_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitete die Front-End-Architektur für Immobilientechnologieprodukte mit disziplinierten Systemen und ausgefeilter UI-Bereitstellung.`)
};

const es_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lideró la arquitectura front-end para productos de tecnología inmobiliaria con sistemas disciplinados y una entrega de interfaz de usuario pulida.`)
};

const fr_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A dirigé l'architecture frontale pour les produits de technologie immobilière avec des systèmes disciplinés et une livraison d'interface utilisateur soignée.`)
};

const pt_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liderou a arquitetura front-end para produtos de tecnologia imobiliária com sistemas disciplinados e entrega de UI refinada.`)
};

const zh_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用严谨的体系和精致的 UI 交付，主导房地产科技产品的前端架构。`)
};

const tr_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disiplinli sistemler ve özenli arayüz sunumuyla gayrimenkul teknolojisi ürünlerinde ön uç mimarisine öncülük etme.`)
};

const ru_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководил разработкой интерфейсной архитектуры для продуктов в сфере недвижимости с дисциплинированными системами и отточенным пользовательским интерфейсом.`)
};

const pl_experience_findus_proptech_summary = /** @type {(inputs: Experience_Findus_Proptech_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kierował architekturą front-end dla produktów technologii nieruchomości ze zdyscyplinowanymi systemami i dopracowanym interfejsem użytkownika.`)
};

/**
* | output |
* | --- |
* | "Led the front-end architecture for property technology products with disciplined systems and polished UI delivery." |
*
* @param {Experience_Findus_Proptech_SummaryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_findus_proptech_summary = /** @type {((inputs?: Experience_Findus_Proptech_SummaryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Findus_Proptech_SummaryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_findus_proptech_summary(inputs)
	if (locale === "bn") return bn_experience_findus_proptech_summary(inputs)
	if (locale === "de") return de_experience_findus_proptech_summary(inputs)
	if (locale === "es") return es_experience_findus_proptech_summary(inputs)
	if (locale === "fr") return fr_experience_findus_proptech_summary(inputs)
	if (locale === "pt") return pt_experience_findus_proptech_summary(inputs)
	if (locale === "zh") return zh_experience_findus_proptech_summary(inputs)
	if (locale === "tr") return tr_experience_findus_proptech_summary(inputs)
	if (locale === "ru") return ru_experience_findus_proptech_summary(inputs)
	if (locale === "pl") return pl_experience_findus_proptech_summary(inputs)
	return en_experience_findus_proptech_summary(inputs)
});